<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">

        <v-card class="planilla-card pa-4" outlined v-model="show">
            <div ref="printArea">
                <!-- CABECERA -->
                <v-row no-gutters align="center">
                    <v-col cols="12" sm="1" md="1" class="d-flex justify-center mb-2 mb-md-0">
                        <v-img src="images/ICSSA.JPG" max-width="110" contain />
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="text-center">
                        <div class="titulo-principal">
                            PLANILLA DE CARACTERÍSTICAS TÉCNICAS
                        </div>
                        <div class="subtitulo-principal">
                            TABLEROS DE MEDIA TENSIÓN
                        </div>
                    </v-col>

                    <v-col cols="12" sm="2" md="2">
                        Código Nº: {{ codigo }}
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="d-flex justify-end">
                        <v-btn small color="green darken-2" dark @click="imprimirPDF">
                            <v-icon left>mdi-printer</v-icon>
                            Imprimir
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                        <v-btn icon @click="show = false" color="black">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                    </v-col>
                </v-row>
                <v-divider class="my-4" />

                <!-- ====================== -->
                <!-- 1. DATOS GENERALES     -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        DATOS GENERALES
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                Nº OT: {{ numot }}
                            </v-col>

                            <v-col cols="12" sm="2" md="2">
                                Fecha: {{ fecha }}
                            </v-col>

                            <v-col cols="12" sm="4" md="6">
                                Cliente: {{ numcliente }} - {{ cliente }}
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                Obra: {{ numobra }} - {{ obra }}
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                Descripción: {{ descr }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                Modelo: {{ modelo }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- 2. VALORES NOMINALES   -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        VALORES NOMINALES
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Tensión nominal: {{ tension }} V
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Intensidad nominal / barras principales: {{ intensidad }} A
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Frecuencia: {{ frecuencia }} Hz
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Potencia CC: {{ potencia }} MVA
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Corriente inicial C.C. (térmica): {{ corrini }} kA
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Corriente dinámica C.C. (cresta): {{ corrdin }} kA
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Tensión de ensayo a Frecuencia Industrial: {{ tenfi }} kV
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Tensión de ensayo a impulso: {{ tenim }} kV
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                Tensión auxiliar de comando: {{ tenaux }}

                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <div class="mb-1 text-caption font-weight-medium">
                                    Tipo tensión auxiliares
                                </div>
                                <v-radio-group v-model="tenauxvc" row hide-details class="mt-0">
                                    <v-radio label="AC" value="AC" />
                                    <v-radio label="DC" value="DC" />
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                Normas de aplicación: {{ normas }}

                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- 3. TIPO CONSTRUCTIVO   -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        TIPO CONSTRUCTIVO
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense hide-details v-model="tipoconst1" true-value="ON" false-value=""
                                    label="Abierta" />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense hide-details v-model="tipoconst2" true-value="ON" false-value=""
                                    label="MetalCad" />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense hide-details v-model="tipoconst3" true-value="ON" false-value=""
                                    label="Antiarco" />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense hide-details v-model="tipoconst4" true-value="ON" false-value=""
                                    label="Compacta" />
                            </v-col>
                            <v-col cols="12" sm="4" md="4" class="d-flex align-center">
                                <v-checkbox dense hide-details v-model="tipoconst5" true-value="ON" false-value=""
                                    label="Otras: " class="mr-2" /> {{ tipoconstot }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- 4. MONTAJE / INGRESOS / SALIDAS / ESTRUCTURA / EMPALMES -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        MONTAJE, INGRESOS, SALIDAS
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                <div class="font-subtitle mb-1">Tipo de montaje</div>
                                <v-checkbox dense v-model="montajei" label="Interior" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="montajee" label="Intemperie" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="montajeo" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                                Grado de Protección IP: {{ gradoip }}
                            </v-col>

                            <v-col cols="12" sm="4" md="4">
                                <div class="font-subtitle mb-1">Ingreso de cables</div>
                                <v-checkbox dense v-model="ingresoi" label="Inferior" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="ingresos" label="Superior" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="ingresop" label="Posterior" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="ingresol" label="Lateral" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="ingresoo" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>

                            <v-col cols="12" sm="4" md="4">
                                <div class="font-subtitle mb-1">Salidas de cables</div>
                                <v-checkbox dense v-model="salidai" label="Inferior" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="salidas" label="Superior" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="salidap" label="Posterior" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="salidal" label="Lateral" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="salidao" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        CARPINTERÍA METÁLICA
                    </div>
                    <v-card-text class="pt-4 pb-2">

                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Estructura</div>
                                <v-checkbox dense v-model="estructura1" label="3,2 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="estructura2" label="2,5 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="estructura3" label="2 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="estructura4" label="1,6 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="estructura5" label="Galvanizada" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="estructura6" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Cerramientos</div>
                                <v-checkbox dense v-model="cerramiento1" label="3,2 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="cerramiento2" label="2,5 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="cerramiento3" label="2 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="cerramiento4" label="1,6 mm" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="cerramiento5" label="Galvanizado" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="cerramiento6" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Piso</div>
                                <v-checkbox dense v-model="piso1" label="Chapa Galvanizada" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="piso2" label="Aluminio" true-value="ON" false-value=""
                                    hide-details />
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="piso3" label="Espesor:" true-value="ON" false-value=""
                                        hide-details class="mr-2" />
                                    {{ pisoe }}
                                </div>
                                <v-checkbox dense v-model="piso4" label="Otros" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Zócalo</div>
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="zocalo1" label="PNU N" true-value="ON" false-value=""
                                        hide-details class="mr-2" />
                                    {{ zocalopnu }}
                                </div>
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="zocalo2" label="Chapa, espesor" true-value="ON"
                                        false-value="" hide-details class="mr-2" />
                                    {{ zocalochapa }}
                                </div>
                                <v-checkbox dense v-model="zocalo3" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <!-- ====================== -->
                <!-- 7. CERRAMIENTOS / ZÓCALOS -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        CERRAMIENTOS
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Delanteros</div>
                                <v-checkbox dense v-model="cerramientodel1" label="Fijo" true-value="ON" false-value=""
                                    hide-details />
                                Bisagra: {{ cerramientodel2 }}
                                Cierre: {{ cerramientodel3 }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Delantero inferior</div>
                                <v-checkbox dense v-model="cerramientodel4" label="Fijo" true-value="ON" false-value=""
                                    hide-details />
                                Bisagra: {{ cerramientodel5 }}
                                Cierre: {{ cerramientodel6 }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Traseros</div>
                                <v-checkbox dense v-model="cerramientotras1" label="Fijo" true-value="ON" false-value=""
                                    hide-details />
                                Bisagra: {{ cerramientotras2 }}
                                Cierre: {{ cerramientotras3 }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Trasero inferior</div>
                                <v-checkbox dense v-model="cerramientotras4" label="Fijo" true-value="ON" false-value=""
                                    hide-details />
                                Bisagra: {{ cerramientotras5 }}
                                Cierre: {{ cerramientotras6 }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <!-- ====================== -->
                <!-- 6. TRATAMIENTOS        -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        TRATAMIENTOS SUPERFICIALES
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <div class="font-subtitle mb-1">Reverso de Puertas</div>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Color: {{ tratamrpcolor }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <!-- <div class="mb-1 text-caption font-weight-medium"> -->
                                Terminación:
                                <v-radio-group v-model="tratamrpterm" row hide-details class="mt-0">
                                    <v-radio label="Texturado" value="V1" />
                                    <v-radio label="Brillante" value="V2" />
                                    <v-radio label="Semi-mate" value="V3" />
                                    <v-radio label="Ninguno" value="V4" />
                                </v-radio-group>
                                <!-- </div> -->
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Espesor: {{ tratamrpesp }} µm
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />

                        <div class="font-subtitle mb-1">Exterior</div>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Color: {{ tratamextcolor }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <!-- <div class="mb-1 text-caption font-weight-medium"> -->
                                Terminación:
                                <v-radio-group v-model="tratamextterm" row hide-details class="mt-0">
                                    <v-radio label="Texturado" value="V1" />
                                    <v-radio label="Brillante" value="V2" />
                                    <v-radio label="Semi-mate" value="V3" />
                                    <v-radio label="Ninguno" value="V4" />
                                </v-radio-group>
                                <!-- </div> -->
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Espesor: {{ tratamextesp }} µm
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />
                        <div class="font-subtitle mb-1">Interior</div>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Color: {{ tratamintcolor }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <!-- <div class="mb-1 text-caption font-weight-medium"> -->
                                Terminación:
                                <v-radio-group v-model="tratamintterm" row hide-details class="mt-0">
                                    <v-radio label="Texturado" value="V1" />
                                    <v-radio label="Brillante" value="V2" />
                                    <v-radio label="Semi-mate" value="V3" />
                                    <v-radio label="Ninguno" value="V4" />
                                </v-radio-group>
                                <!-- </div> -->
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Espesor: {{ tratamintesp }} µm
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />
                        <div class="font-subtitle mb-1">Placas de montaje</div>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Color: {{ tratampmcolor }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <!-- <div class="mb-1 text-caption font-weight-medium"> -->
                                Terminación:
                                <v-radio-group v-model="tratampmterm" row hide-details class="mt-0">
                                    <v-radio label="Texturado" value="V1" />
                                    <v-radio label="Brillante" value="V2" />
                                    <v-radio label="Semi-mate" value="V3" />
                                    <v-radio label="Ninguno" value="V4" />
                                    <v-radio label="Galvanizado" value="V5" />
                                </v-radio-group>
                                <!-- </div> -->
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Espesor: {{ tratampmesp }} µm
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />
                        <div class="font-subtitle mb-1">Rejas de protección</div>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Color: {{ tratamxpcolor }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <!-- <div class="mb-1 text-caption font-weight-medium"> -->
                                Terminación:
                                <v-radio-group v-model="tratamxpterm" row hide-details class="mt-0">
                                    <v-radio label="Texturado" value="V1" />
                                    <v-radio label="Brillante" value="V2" />
                                    <v-radio label="Semi-mate" value="V3" />
                                    <v-radio label="Ninguno" value="V4" />
                                    <v-radio label="Galvanizado" value="V5" />
                                </v-radio-group>
                                <!-- </div> -->
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Espesor: {{ tratamxpesp }} µm
                            </v-col>
                        </v-row>
                        <v-divider class="my-3" />
                        <div class="font-subtitle mb-1">Pintura Anticondensante</div>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                <v-radio-group v-model="pinturaac" row hide-details class="mt-0">
                                    <v-radio label="SI" value="SI" />
                                    <v-radio label="NO" value="NO" />
                                </v-radio-group>
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />


                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- 5. SISTEMA DE BARRAS / COLORES / PT -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        SISTEMA DE BARRAS PRINCIPALES
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                In: {{ barrain }} A
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                Dimensiones Fase: {{ barrafase }} mm2
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />

                        <div class="font-subtitle mb-1">Colores</div>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Color fase R: {{ fasercolor }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Color fase S: {{ fasescolor }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Color fase T: {{ fasetcolor }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Color Neutro: {{ neutrocolor }}
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />

                        <v-row>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Barras</div>
                                <v-checkbox dense v-model="barra1" label="Desnudo" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="barra2" label="Pintado" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="barra3" label="Estañado" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="barra4" label="Plateado" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="barra5" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Termocontraíbles</div>
                                <v-radio-group v-model="termocontraible" row hide-details class="mt-0">
                                    <v-radio label="SI" value="SI" />
                                    <v-radio label="NO" value="NO" />
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Empalmes</div>
                                <v-checkbox dense v-model="empalme1" label="Desnudo" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="empalme2" label="Estañado" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="empalme3" label="Plateado" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="empalme4" label="Protegido" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="empalme5" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>

                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Aisladores soporte</div>
                                Resistencia: {{ aislaresist }} Kg
                                Distancia máxima: {{ aisladmax }} mm
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- BARRAS  -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        BARRAS DERIVACIÓN:
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2">
                                <div class="font-subtitle mb-1">Celda Tipo: {{ nomcelda1 }}</div>
                                In: {{ barraentin1 }} A
                                Dimensiones: {{ barraentdim1 }} mm2
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <div class="font-subtitle mb-1">Celda Tipo: {{ nomcelda2 }}</div>
                                In: {{ barraentin2 }} A
                                Dimensiones: {{ barraentdim2 }} mm2
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <div class="font-subtitle mb-1">Celda Tipo: {{ nomcelda3 }}</div>
                                In: {{ barraentin3 }} A
                                Dimensiones: {{ barraentdim3 }} mm2
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <div class="font-subtitle mb-1">Celda Tipo: {{ nomcelda4 }}</div>
                                In: {{ barraentin4 }} A
                                Dimensiones: {{ barraentdim4 }} mm2
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <div class="font-subtitle mb-1">Celda Tipo: {{ nomcelda5 }}</div>
                                In: {{ barraentin5 }} A
                                Dimensiones: {{ barraentdim5 }} mm2
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!--  PT -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        SISTEMA DE PUESTA A TIERRA:
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Barra General</div>
                                Dimensiones: {{ ptbarradim }} mm2
                                Color: {{ ptbarracolor }}
                            </v-col>

                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Derivaciones</div>
                                Dimensiones: {{ ptderivdim }} mm2
                                Color: {{ ptderivcolor }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <div class="font-subtitle mb-1">Trenzas flexibles</div>
                                Dimensiones: {{ pttrenzasdim }} mm2
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- 8. CALEFACCIÓN / TERMOS / SIST. AUX / ACCESORIOS / EMBALAJE -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        SISTEMAS AUXILIARES
                    </div>
                    <v-card-text class="pt-4 pb-2">

                        <!-- Subtítulo -->
                        <v-row dense>
                            <v-col cols="4"></v-col>
                            <v-col cols="8" class="text-center">
                                Compartimientos de
                            </v-col>
                        </v-row>

                        <!-- Encabezados comunes -->
                        <v-row class="font-weight-bold" dense>
                            <v-col cols="4"></v-col>
                            <v-col cols="2">Baja tensión</v-col>
                            <v-col cols="2">Equipo</v-col>
                            <v-col cols="2">Cables</v-col>
                            <v-col cols="2">
                                {{ sistaux }}
                            </v-col>
                        </v-row>

                        <!-- Iluminación -->
                        <v-row align="center" dense>
                            <v-col cols="2">
                                Iluminación
                            </v-col>
                            <v-col cols="2">
                                {{ iluminacionv }} V
                            </v-col>

                            <v-col cols="2" class="text-center">
                                <v-checkbox dense v-model="iluminacion1" true-value="ON" false-value="" hide-details />
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-checkbox dense v-model="iluminacion2" true-value="ON" false-value="" hide-details />
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-checkbox dense v-model="iluminacion3" true-value="ON" false-value="" hide-details />
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-checkbox dense v-model="iluminacion4" true-value="ON" false-value="" hide-details />
                            </v-col>
                        </v-row>

                        <!-- Calefacción -->
                        <v-row align="center" dense>
                            <v-col cols="2">
                                Calefacción
                            </v-col>
                            <v-col cols="2">
                                {{ calefaccionv }} V
                            </v-col>

                            <v-col cols="2" class="text-center" align="center">
                                <v-checkbox dense v-model="calefaccion1" true-value="ON" false-value="" hide-details />
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-checkbox dense v-model="calefaccion2" true-value="ON" false-value="" hide-details />
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-checkbox dense v-model="calefaccion3" true-value="ON" false-value="" hide-details />
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-checkbox dense v-model="calefaccion4" true-value="ON" false-value="" hide-details />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        ENCLAVAMIENTO
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="enclavamiento1" label="Estándar" true-value="ON"
                                    false-value="" hide-details />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="enclavamiento2" label="Ver Descripción" true-value="ON"
                                    false-value="" hide-details />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="enclavamiento3" label="Ninguno" true-value="ON"
                                    false-value="" hide-details />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <!-- ====================== -->
                <!--  ACCESORIOS  -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        ACCESORIOS
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                <v-checkbox dense v-model="accesorio1" label="Cepo" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="accesorio5" label="Porta planos" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="accesorio6" label="Reja protectora" true-value="ON"
                                    false-value="" hide-details />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-checkbox dense v-model="accesorio7" label="Visores" true-value="ON" false-value=""
                                    hide-details />
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="accesorio8" label="Mímico" true-value="ON" false-value=""
                                        hide-details />
                                    Color: {{ mimicocolor }}
                                </div>
                                <v-checkbox dense v-model="accesorio9" label="Carteles - calcomanías" true-value="ON"
                                    false-value="" hide-details />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="accesorio4" label="Tablero porta manijas" true-value="ON"
                                        false-value="" class="mr-2" hide-details />
                                    Cantidad: {{ accesorio4cantidad }}
                                </div>
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="accesorio2" label="Carro de extracción" class="mr-2"
                                        true-value="ON" false-value="" hide-details />
                                    Cantidad: {{ accesorio2cantidad }}
                                </div>
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="accesorio3" label="Juego de manijas" class="mr-2"
                                        true-value="ON" false-value="" hide-details />
                                    Cantidad: {{ accesorio3cantidad }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        EMBALAJE
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="embalaje1" label="Cartón" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="embalaje2" label="Film" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="embalaje3" label="Madera" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="embalaje4" label="Exportación" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-checkbox dense v-model="embalaje5" label="Otro" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>


                <!-- ====================== -->
                <!-- 9. ENSAYOS             -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        ENSAYOS
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                <v-checkbox dense v-model="ensayo1" label="Control visual y dimensional" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="ensayo2" label="Espesor pintura" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="ensayo3" label="Adherencia" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="ensayo4" label="Frecuencia industrial principal"
                                    true-value="ON" false-value="" hide-details />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-checkbox dense v-model="ensayo5" label="Frecuencia industrial secundaria"
                                    true-value="ON" false-value="" hide-details />
                                <v-checkbox dense v-model="ensayo6" label="Impulso" true-value="ON" false-value=""
                                    hide-details />
                                <v-checkbox dense v-model="ensayo7" label="Resistencia contacto principal"
                                    true-value="ON" false-value="" hide-details />
                                <v-checkbox dense v-model="ensayo8" label="Calentamiento" true-value="ON" false-value=""
                                    hide-details />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-checkbox dense v-model="ensayo9" label="Funcional mecánico" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="ensayo10" label="Funcional eléctrico" true-value="ON"
                                    false-value="" hide-details />
                                <v-checkbox dense v-model="ensayo11" label="Inyección de corriente" true-value="ON"
                                    false-value="" hide-details />
                                <div class="d-flex align-center">
                                    <v-checkbox dense v-model="ensayo12" label="Otros:" class="mr-2" true-value="ON"
                                        false-value="" hide-details />
                                    {{ ensayootro }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- 10. DOCUMENTACIÓN / OBS -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        DOCUMENTACIÓN COMPLEMENTARIA
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        {{ documentacion }}
                    </v-card-text>
                </v-card>

                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        OBSERVACIONES
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        {{ observ }}
                    </v-card-text>
                </v-card>

                <!-- ====================== -->
                <!-- 11. ELABORÓ / APROBÓ  -->
                <!-- ====================== -->
                <v-card flat class="seccion-card mb-4">
                    <div class="seccion-header">
                        RESPONSABLES Y ESTADO
                    </div>
                    <v-card-text class="pt-4 pb-2">
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                Elaboró: {{ elaboro }}
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                Fecha elaboración: {{ fechaelab }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                Aprobó: {{ aprobo }}
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                Fecha aprobación: {{ fechaaprob }}
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                Estado: {{ estado }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- BOTONES -->
                <v-divider class="mt-2 mb-4" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
export default {
    name: 'EI025NuevoBT',
    data() {
        return {
            deshabilitar: false,
            codreg: '',
            numot: '',
            fecha: moment().format("DD/MM/YYYY"),
            cliente: '',
            numcliente: '',
            obra: '',
            numobra: '',
            descr: '',
            modelo: '',
            normas: '',

            // Valores nominales
            tension: '',
            intensidad: '',
            frecuencia: '',
            potencia: '',
            corrini: '',
            corrdin: '',
            tenfi: '',
            tenim: '',
            tenaux: '',
            tenauxvc: '',

            // Tipo constructivo
            tipoconst1: '',
            tipoconst2: '',
            tipoconst3: '',
            tipoconst4: '',
            tipoconst5: '',
            tipoconstot: '',

            // Montaje / ingresos / salidas / estructura / empalmes / enclavamientos
            montajei: '',
            montajee: '',
            montajeo: '',
            gradoip: '',
            ingresoi: '',
            ingresol: '',
            ingresoo: '',
            ingresop: '',
            ingresos: '',
            salidai: '',
            salidal: '',
            salidao: '',
            salidap: '',
            salidas: '',
            ingresootro: '',
            salidaotro: '',
            montajeotro: '',
            estructura1: '',
            estructura2: '',
            estructura3: '',
            estructura4: '',
            estructura5: '',
            estructura6: '',
            estructuraotro: '',
            piso1: '',
            piso2: '',
            piso3: '',
            piso4: '',
            pisoe: '',
            pisootro: '',
            empalme1: '',
            empalme2: '',
            empalme3: '',
            empalme4: '',
            empalme5: '',
            empalmeotro: '',
            enclavamiento1: '',
            enclavamiento2: '',
            enclavamiento3: '',

            barra1: '',
            barra2: '',
            barra3: '',
            barra4: '',
            barra5: '',
            barraotro: '',
            // Sistema de barras / PT / colores / aislamiento
            barraentin1: '',
            barraentin2: '',
            barraentin3: '',
            barraentin4: '',
            barraentin5: '',
            barraentin: '',
            barrasalin: '',
            barraentdim1: '',
            barraentdim2: '',
            barraentdim3: '',
            barraentdim4: '',
            barraentdim5: '',
            barrasaldim: '',
            barrafase: '',
            barraneutro: '',
            neutrocolor: '',
            barrain: '',
            fasercolor: '',
            fasescolor: '',
            fasetcolor: '',
            ptbarracolor: '',
            ptbarradim: '',
            ptcablecolor: '',
            ptcabledim: '',
            ptderivcolor: '',
            ptderivdim: '',
            pttrenzasdim: '',
            aislaresist: '',
            aisladmax: '',

            // Tratamientos
            tratamextcolor: '',
            tratamextterm: '',
            tratamextesp: '',
            tratamintcolor: '',
            tratamintterm: '',
            tratamintesp: '',
            tratampmcolor: '',
            tratampmterm: '',
            tratampmesp: '',
            tratamrpcolor: '',
            tratamrpterm: '',
            tratamrpesp: '',
            tratamxpcolor: '',
            tratamxpterm: '',
            tratamxpesp: '',

            // Cerramientos / zócalos
            cerramiento1: '',
            cerramiento2: '',
            cerramiento3: '',
            cerramiento4: '',
            cerramiento5: '',
            cerramiento6: '',
            cerramientodel1: '',
            cerramientootro: '',
            cerramientodel2: '',
            cerramientodel3: '',
            cerramientodel4: '',
            cerramientodel5: '',
            cerramientodel6: '',
            cerramientotras1: '',
            cerramientotras2: '',
            cerramientotras3: '',
            cerramientotras4: '',
            cerramientotras5: '',
            cerramientotras6: '',
            zocalo1: '',
            zocalo2: '',
            zocalo3: '',
            zocalochapa: '',
            zocalopnu: '',
            zocalo: '',

            iluminacionv: '',
            iluminacion1: '',
            iluminacion2: '',
            iluminacion3: '',
            iluminacion4: '',


            // Calefacción / termos / sist. aux
            calefaccion1: '',
            calefaccion2: '',
            calefaccion3: '',
            calefaccion4: '',
            calefaccionv: '',
            termo1: '',
            termo2: '',
            termo3: '',
            termocontraible: '',
            sistaux: '',
            pinturaac: '',

            // Accesorios
            accesorio1: '',
            accesorio2: '',
            accesorio2cantidad: '',
            accesorio3: '',
            accesorio3cantidad: '',
            accesorio4: '',
            accesorio4cantidad: '',
            accesorio5: '',
            accesorio6: '',
            accesorio7: '',
            accesorio8: '',
            accesorio9: '',
            accesorio10: '',
            mimicocolor: '',

            // Embalaje
            embalaje1: '',
            embalaje2: '',
            embalaje3: '',
            embalaje4: '',
            embalaje5: '',

            // Ensayos
            ensayo1: '',
            ensayo2: '',
            ensayo3: '',
            ensayo4: '',
            ensayo5: '',
            ensayo6: '',
            ensayo7: '',
            ensayo8: '',
            ensayo9: '',
            ensayo10: '',
            ensayo11: '',
            ensayo12: '',
            ensayootro: '',

            // Documentación / observaciones
            documentacion: '',
            observ: '',

            // Responsables / estado
            elaboro: '',
            aprobo: '',
            fechaelab: '',
            fechaaprob: '',
            estado: '',

            nomcelda1: '',
            nomcelda2: '',
            nomcelda3: '',
            nomcelda4: '',
            nomcelda5: '',

            // Combos de ejemplo (reemplazá con datos reales)
            clientes: [],
            obras: [],
            personas: [],
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
        };
    },
    props: ["visible", "codigo"],
    // watch: {
    //     cliente(newVal) {
    //         this.numcliente = this.cliente.numcliente;
    //         this.listadoobras();
    //     },
    //     obra(newVal) {
    //         this.numobra = this.obra.numobra;
    //         this.cargarcodigo();
    //     },
    // },
    computed: {
        show: {
            get() {
                if (this.visible == true) {//this.mostrar = true;
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        listadoclientes() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoclientes?", {
                    params: {
                        filtrocliente: '',
                    },
                })
                .then((response) => {
                    self.clientes = response.data;
                })
                .catch((error) => {
                    self.clientes = [];
                    console.log(error);
                });
        },
        listadoobras() {
            //this.obras = [];
            console.log("ENTRO a obras")
            let self = this;
            axios
                .get("/Ingenieria/Listadoobras?", {
                    params: {
                        filtroobra: '',
                        filtrocliente: self.numcliente,
                    },
                })
                .then((response) => {
                    self.obras = response.data;
                })
                .catch((error) => {
                    self.obras = [];
                    console.log(error);
                });
        },
        cargardatos() {
            let self = this;

            axios
                .get("/Ingenieria/CargarEI025BT", {
                    params: {
                        codigo: self.codigo,
                    },
                })
                .then((response) => {
                    if (!response.data) return;

                    const datos = response.data;

                    // 🔹 Copia automática: PascalCase → camelCase
                    Object.keys(datos).forEach((key) => {
                        const camelKey =
                            key.charAt(0).toLowerCase() + key.slice(1);

                        if (camelKey in self.$data) {
                            self[camelKey] = datos[key];
                        }
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        cargarcodigo() {
            //this.obras = [];
            let self = this;
            axios
                .get("/Ingenieria/CargarcodigoEI025?", {
                    params: {
                        numobra: self.obra.numobra,
                        numcliente: self.cliente.numcliente,
                    },
                })
                .then((response) => {
                    self.codigo = response.data;
                    self.codreg = response.data;
                })
                .catch((error) => {
                    self.obras = [];
                    console.log(error);
                });
        },

        onCancelar() {
            this.$emit('cancelar');
        },
        buildPayloadEI025() {
            // toma todo el data del componente y excluye flags de UI
            const {
                deshabilitar,
                clientes,
                obras,
                personas,
                estados,
                ...datos
            } = this.$data;

            const payload = {
                ...datos,
                codigo: this.codigo,
                tipoplanilla: "2",
            };
            return payload;
        },
        vaciarModels() {
            const initialState = this.$options.data.call(this);

            Object.keys(initialState).forEach((key) => {
                this[key] = initialState[key];
            });
        },

        imprimirPDF() {
            // Asegurar que existe el contenido
            const el = this.$refs.printArea;
            if (!el) return;

            // Tomar los estilos actuales (incluye Vuetify y tus estilos)
            const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
                .map(node => node.outerHTML)
                .join('\n');

            // HTML a imprimir
            const html = `
    <html>
      <head>
        <title>EI025 - ${this.codigo || ""}</title>
        ${styles}
        <style>
          /* Ajustes típicos de impresión */
          @page { size: A4; margin: 10mm; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .v-application--wrap { min-height: auto !important; }
        </style>
      </head>
      <body>
        ${el.outerHTML}
      </body>
    </html>
  `;

            // Abrir ventana e imprimir
            const win = window.open('', '_blank');
            win.document.open();
            win.document.write(html);
            win.document.close();

            // Esperar render y disparar impresión
            win.onload = () => {
                win.focus();
                win.print();
                // opcional: cerrar luego
                win.close();
            };
        },

    },
};
</script>

<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}

.v-input--selection-controls {
    label {
        margin: 0 !important;
    }
}
</style>
<style scoped>
.v-checkbox ::v-deep label {
    display: flex;
    align-items: center;
    margin: 0 !important;
}

.planilla-card {
    border-width: 2px !important;
    border-color: #008000 !important;
    border-radius: 8px;
}

.titulo-principal {
    font-family: Arial, sans-serif;
    font-weight: 700;
    font-size: 1.1rem;
    text-transform: uppercase;
}

.subtitulo-principal {
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
}

.seccion-card {
    border: 1px solid #cfd8dc;
    border-radius: 6px;
}

.seccion-header {
    background: linear-gradient(90deg, #008000, #006400);
    color: #fff;
    font-weight: 600;
    font-size: 0.85rem;
    padding: 6px 12px;
    text-transform: uppercase;
    border-radius: 6px 6px 0 0;
}

.font-subtitle {
    font-weight: 600;
    font-size: 0.85rem;
}
</style>
